module.exports = __webpack_public_path__ + "static/img/QR1.d20cec5b.jpg";